export const columns = [
  {
    title: '保函编号',
    dataIndex: 'code',
    scopedSlots: { customRender: 'code' },
    width:100,
  },
  {
    title: '项目名称',
    dataIndex: 'project',
    scopedSlots: { customRender: 'project' },
    width: 170,
  },
  // {
  //   title: '业主',
  //   dataIndex: 'proprietor',
  //   scopedSlots: { customRender: 'proprietor' },
  //   width: 270,
  // },
  {
    title: '开标日期',
    dataIndex: 'bidder_date',
    scopedSlots: { customRender: 'bidder_date' },
    width: 100,
  },
  {
    title: '保函状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    width: 100,
  },
  // {
  //   title: '经办人',
  //   dataIndex: 'user_name',
  //   width: 200,
  // },
  // {
  //   title: '推荐码',
  //   dataIndex: 'p_user_id',
  //   width: 100,
  // },
  // {
  //   title: '发票信息',
  //   dataIndex: 'is_invoice',
  //   customRender: (_, record) => {
  //     let texts = '';
  //     switch (record.is_invoice) {
  //       case 0:
  //         texts = '等待开票';
  //         break;
  //       case 1:
  //         texts = '开票中';
  //         break;
  //       case 2:
  //         texts = '开票完成';
  //         break;
  //       case 3:
  //         texts = '换开专票中';
  //         break;
  //       case 4:
  //         texts = '开专票完成';
  //         break;
  //     }
  //     return texts;
  //   },
  //   width: 100,
  // },
  // {
  //   title: '担保金额',
  //   dataIndex: 'money',
  //   customRender: (text) => {
  //     return text + '元';
  //   },
  //   width: 110,
  // },
  // {
  //   title: '担保费率',
  //   dataIndex: 'rate',
  //   customRender: (text) => {
  //     return text + '%';
  //   },
  //   width: 80,
  // },
  {
    title: '担保费',
    dataIndex: 'poundage',
    customRender: (text) => {
      return text + '元';
    },
    width: 100,
  },
  // {
  //   title: '实付担保费',
  //   dataIndex: 'real_poundage',
  //   customRender: (text) => {
  //     return text + '元';
  //   },
  //   width: 100,
  // },
  // {
  //   title: '支付时间',
  //   dataIndex: 'pay_time',
  //   customRender: (text) => {
  //     return text === '0001-01-01 00:00:00' ? '' : text;
  //   },
  //   width: 150,
  // },
  // {
  //   title: '出函时间',
  //   dataIndex: 'sign_time',
  //   customRender: (text) => {
  //     return text === '0001-01-01 00:00:00' ? '' : text;
  //   },
  //   width: 150,
  // },
  // {
  //   title: '审核时间',
  //   dataIndex: 'review_time',
  //   customRender: (text) => {
  //     return text === '0001-01-01 00:00:00' ? '' : text;
  //   },
  //   width: 150,
  // },
  {
    title: '申请人',
    dataIndex: 'bidder',
    scopedSlots: { customRender: 'bidder' },
    width: 100,
  },
  // {
  //   title: '社会信用代码',
  //   dataIndex: 'taxNumber',
  //   width: 190,
  // },
  // {
  //   title: '地址',
  //   dataIndex: 'companyAddress',
  //   width: 200,
  // },
  // {
  //   title: '开户行',
  //   dataIndex: 'bankName',
  //   width: 200,
  // },
  // {
  //   title: '开户行账号',
  //   dataIndex: 'bankAccount',
  //   width: 180,
  // },
  // {
  //   title: '操作',
  //   dataIndex: 'action',
  //   scopedSlots: { customRender: 'action' },
  //   width: 60,
  // },
];
